<template>
  <div class="dashboard-settings-overview">
    <SettingsTitleBar/>
    <div class="d-flex flex-wrap" id="cards">
      <b-card v-for="({key, title, viewComponent}) in cards" :title="title" :key="key" @click="$router.push('settings/'+key)">
        <component :is="viewComponent"></component>
        <i class="fas fa-edit" id="edit-card"/>
      </b-card>
    </div>
  </div>



</template>

<style scoped lang="scss">
@import '~scss/colors';
h1 {
  margin-top: 0;
  font-size: 2rem;
}
#cards {
  // Offset the outer margin of the cards, so that the cards line up nicely with the settings
  margin: -1em;
}


// Edit button appears on right
  .card {
      position: relative;
      margin: 1em;
      min-width: 12em;
      max-width: 18em;
      flex-grow: 1;
      background: $white;
  }
    .card:hover {
      border-color: #333;
      background: #f8f8f8;
      #edit-card {
        color: #333;
      }
    }

    #edit-card {
      cursor: pointer;
      position: absolute;
      right: 1em;
      top: 0.8em;
      color: #aaa;
    }
</style>

<script>
import {mapGetters} from 'vuex';
import CARDS from './cards';
export default {
  computed: {
    ...mapGetters(['flags']),
    cards() {
      return CARDS.filter(({flag}) => !flag || this.flags[flag]);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/settings/Overview.vue